import React from "react";
import PropTypes from "prop-types";
import { Auth } from 'aws-amplify';
import { Link } from 'react-router-dom'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import InputAdornment from "material-ui/Input/InputAdornment";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import LoginCard from "components/Cards/LoginCard.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

class ForgotPasswordPage extends React.Component {

  errorDefault = {
        username: {state: false, message: null},
        code: {state: false, message: null},
        password: {state: false, message: null},
      };

  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      //cardAnimaton: "cardHidden",
      supportSocial: false, 
      error: this.errorDefault,
      resetState: null,     
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);

  }

  handleSubmit(event){
    event.preventDefault();

    const { username, password, code } = this.state;

    if(this.state.resetState==="code"){
      // Collect confirmation code, then
      Auth.forgotPasswordSubmit(username, code, password)
          .then(data => {
            this.setState({resetState:"done"});
          })
          .catch(error => {

            console.log(error);

            let errorUpdates = {};

            if( !error.message && error.toLowerCase().includes("code")){
              errorUpdates["code"] = {state: true, message: error};
            }

            if(error.message && error.message.toLowerCase().includes("code")){
              errorUpdates["code"] = {state: true, message: error.message};
            }

            if( !error.message && error.toLowerCase().includes("password")){
              errorUpdates["password"] = {state: true, message: error};
            }

            if(error.message && error.message.toLowerCase().includes("password")){
              errorUpdates["password"] = {state: true, message: error.message};
            }

            console.log(errorUpdates);

            this.setState({error: { ...this.errorDefault, ...errorUpdates }});


          });

    }else{
      // Collect confirmation code, then
      Auth.forgotPassword(username)
          .then(data => {
            this.setState({resetState:"code"});
          })
          .catch(error => {

            let errorUpdates = {};

            if( !error.message && error.toLowerCase().includes("username")){
              errorUpdates["username"] = {state: true, message: error};
            }

            console.log(errorUpdates);

            this.setState({error: { ...this.errorDefault, ...errorUpdates }});


          });
    }

  }

  handleInput(e){
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );

    Auth.currentAuthenticatedUser()
    .then(user => {
        console.log(user);
    })

  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <ItemGrid xs={12} sm={6} md={4}>
              <form>
                <LoginCard
                  customCardClass={classes[this.state.cardAnimaton]}
                  headerColor="rose"
                  cardTitle="Forgot Password"
                  footerAlign="center"
                  footer={
                    <div>
                      <Button color="primary" wd size="lg"  onClick={(e) => this.handleSubmit(e)}>
                        Let&apos;s Go
                      </Button>
                      <Link to={{
                          pathname: '/login',
                          state: {  },
                        }}>Login</Link>
                      </div>
                  }
                  
                  content={content(this.props, this.state, this.handleInput)}
                />
              </form>
            </ItemGrid>
          </GridContainer>
        </div>
      </div>
    );
  }
}

  const content = (props, state, onChange) => {
    switch(state.resetState){
      case "done":
        return resetDone(props, state, onChange);
      case "code":
        return resetCode(props, state, onChange);
      default:
        return reset(props, state, onChange);
    }
  }
  const reset = (props, state, onChange) => (
      <div>
        <CustomInput
          labelText="Username.."
          id="firstname"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Face className={props.classes.inputAdornmentIcon} />
              </InputAdornment>
            ),
            onChange: onChange,
            name: "username",                          
          }}
          error={state.error.username.state?true:false}                                                
        />
      </div>  
    );  

  const resetDone = (props, state, onChange) => (
      <div>
      Done
      </div>  
    );  

const resetCode = (props, state, onChange) => (
    <div>
      <CustomInput
        labelText="Username.."
        id="firstname"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Face className={props.classes.inputAdornmentIcon} />
            </InputAdornment>
          ),
          onChange: onChange,
          name: "username",                          
        }}
        error={state.error.username.state?true:false}
      />
      <CustomInput
        labelText="Password"
        id="password"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <LockOutline
                className={props.classes.inputAdornmentIcon}
              />
            </InputAdornment>
          ),
            onChange: onChange,
            name: "password",
        }}
        error={state.error.password.state?true:false}         
      />
      <CustomInput
        labelText="Code"
        id="code"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <LockOutline
                className={props.classes.inputAdornmentIcon}
              />
            </InputAdornment>
          ),
            onChange: onChange,
            name: "code", 
        }}
        error={state.error.code.state?true:false}        
      />
    </div>  
);

ForgotPasswordPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/views/User/ForgotPasswordPage.jsx